import {z} from 'zod';

export const deactivateContractDialogFormTypeSchema = z.object({
  clear: z.enum(['CLEAR', 'DONT_CLEAR']),
});

export type DeactivateContractDialogFormType = z.infer<
  typeof deactivateContractDialogFormTypeSchema
>;
